/**
 * Log the input as a side effect and return it.
 * @param value
 * @param description
 */
export function probe<T>(value: T, description = 'probe => '): T {
    // eslint-disable-next-line no-console
    console.log(description, value);
    return value;
}
